// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-business-report-indetail-granth',
//   standalone: true,
//   imports: [],
// templateUrl: './business-report-indetail-granth.component.html',
// styleUrl: './business-report-indetail-granth.component.scss'
// })
// export class BusinessReportIndetailGranthComponent {

// }
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-business-report-indetail-granth',
  templateUrl: './business-report-indetail-granth.component.html',
  styleUrl: './business-report-indetail-granth.component.scss'
})
export class BusinessReportIndetailGranthComponent implements OnInit {

  reportData: any[] = [];
  months: string[] = [];
  startDate: any;
  endDate: any;
  today: Date = new Date();

  constructor(
    private service: DigisubservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;
    this.getBusinessReport();
  }

  private get storageKey(): string {
    return `business_report_${this.startDate}_${this.endDate}`;
  }

  // ================= API =================
  getBusinessReport(): void {
    const payload = {
      start_date: this.startDate,
      end_date: this.endDate,
      rep_name: this.data?.rep_name || '',
      office_rep_name: this.data?.office_rep_name || [],
      district: this.data?.district || [],

      taluka: this.data?.taluka || []
    };

    this.service.getGranthBusinessReport1(payload).subscribe((res: any) => {
      if (!res || res.status !== 'success') return;

      this.months = res.months || [];

      this.reportData = (res.data || []).map((group: any) => {
        const rows = (group.rows || []).map((row: any) => ({
          name: row.rep_name,
          district: row.district,
          taluka: row.taluka,
          ...row,
          totalAmount: Number(row.total_amount) || 0,
          colValue: null,
          tip: '',
          farak: 0
        }));

        return {
          groupName: group.office_rep_name,
          rows,
          monthTotals: this.months.reduce((acc, m) => {
            acc[m] = Number(group.group_totals?.[m] || 0);
            return acc;
          }, {} as any),
          totalAmount: Number(group.group_totals?.total_amount) || 0,
          uddisht: null,
          farak: 0,
          tip: ''
        };
      });

      this.loadFromLocalStorage();
    });
  }

  // ================= ROW LEVEL =================
  calculateRowFarak(row: any): void {
    const uddisht = Number(row.colValue) || 0;
    row.farak = uddisht === 0 ? 0 : Math.round(Number(row.totalAmount) - uddisht);
    this.saveToLocalStorage();
  }

  // ================= GROUP LEVEL =================
  calculateGroupFarak(group: any): void {
    const uddisht = Number(group.uddisht) || 0;
    group.farak = uddisht === 0 ? 0 : Math.round(Number(group.totalAmount) - uddisht);
    this.saveToLocalStorage();
  }

  // ================= DISPLAY HELPERS =================
  getRowFarak(row: any): number {
    return row.farak ?? 0;
  }

  getGroupFarakDisplay(group: any): number {
    return group.farak ?? 0;
  }

  // ================= GROUP TOTAL HELPERS =================
  getGroupUddisht(group: any): number {
    return (group.rows || []).reduce(
      (sum: number, row: any) => sum + (Number(row.colValue) || 0),
      0
    );
  }

  getGroupRowFarak(group: any): number {
    return (group.rows || []).reduce(
      (sum: number, row: any) => sum + this.getRowFarak(row),
      0
    );
  }

  getGroupTotalAmount(group: any): number {
    return (group.rows || []).reduce(
      (sum: number, row: any) => sum + (Number(row.totalAmount) || 0),
      0
    );
  }

  getGroupMonthTotal(group: any, month: string): number {
    return (group.rows || []).reduce(
      (sum: number, row: any) => sum + (Number(row[month]) || 0),
      0
    );
  }

  // ================= GRAND TOTAL HELPERS =================
  get grandTotalAmount(): number {
    return this.reportData.reduce(
      (sum, g) => sum + this.getGroupTotalAmount(g), 0
    );
  }

  get grandTotalUddisht(): number {
    return this.reportData.reduce(
      (sum, g) => sum + this.getGroupUddisht(g), 0
    );
  }

  get grandTotalFarak(): number {
    return this.reportData.reduce(
      (sum, g) => sum + this.getGroupRowFarak(g), 0
    );
  }

  getGrandMonthTotal(month: string): number {
    return this.reportData.reduce(
      (sum, g) => sum + this.getGroupMonthTotal(g, month), 0
    );
  }

  // ================= LOCAL STORAGE =================
  saveToLocalStorage(): void {
    const snapshot = this.reportData.map(g => ({
      groupName: g.groupName,
      uddisht: g.uddisht,
      tip: g.tip || '',
      rows: g.rows.map((r: any) => ({
        name: r.name,
        colValue: r.colValue,
        tip: r.tip || ''
      }))
    }));
    localStorage.setItem(this.storageKey, JSON.stringify(snapshot));
  }

  loadFromLocalStorage(): void {
    const saved = localStorage.getItem(this.storageKey);
    if (!saved) return;

    try {
      const snapshot = JSON.parse(saved) as any[];

      this.reportData.forEach(group => {
        const savedGroup = snapshot.find(g => g.groupName === group.groupName);
        if (!savedGroup) return;

        group.uddisht = savedGroup.uddisht ?? null;
        group.tip = savedGroup.tip || '';
        this.calculateGroupFarak(group);

        group.rows.forEach((row: any) => {
          const savedRow = savedGroup.rows.find((r: any) => r.name === row.name);
          if (!savedRow) return;
          row.colValue = savedRow.colValue ?? null;
          row.tip = savedRow.tip || '';
          this.calculateRowFarak(row);
        });
      });
    } catch (e) {
      console.warn('Error restoring local storage:', e);
    }
  }

  // ================= UTILS =================
  trackByIndex(index: number): number {
    return index;
  }
  printReportA3() {
    const printContent = document.getElementById('print-section');
    if (!printContent) return;

    // Clone content so we can safely remove buttons
    const clonedContent = printContent.cloneNode(true) as HTMLElement;

    // ================= REMOVE BUTTONS ONLY =================
    const buttons = clonedContent.querySelectorAll('.button-container, button, mat-button, mat-raised-button');
    buttons.forEach(btn => btn.remove());

    // ================= FIX INPUT VALUES FOR PRINT =================
    const inputs = clonedContent.querySelectorAll('input');

    inputs.forEach((input: any) => {
      const value = input.value || '';

      const span = document.createElement('span');
      span.textContent = value;

      // keep alignment same
      span.style.display = 'inline-block';
      span.style.width = input.style.width || '60px';
      span.style.textAlign = input.style.textAlign || 'right';

      input.replaceWith(span);
    });

    const WindowPrt = window.open('', '', 'width=1400,height=900');

    if (WindowPrt) {
      WindowPrt.document.open();

      WindowPrt.document.write(`
      <html>
        <head>
          <title>Business Report</title>

          <style>
            @page { size: A3 landscape; margin: 5mm; }

            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: auto;
            }

            th, td {
              border: 1px solid black;
              padding: 6px;
              font-size: 15px;
            }

            thead { display: table-header-group; }
            tfoot { display: table-footer-group; }

            tr { page-break-inside: avoid; }

            div { overflow: visible !important; }

            /* ================= FORCE COLORS ================= */

            thead tr {
              background-color: #f1f1f1 !important;
            }

            tr[style*="b0c4cf"] {
              background-color: #b0c4cf !important;
              font-weight: bold;
            }

            tr[style*="f4b084"] {
              background-color: #f4b084 !important;
              font-weight: bold;
            }

            tfoot tr {
              background-color: #c8753f !important;
              font-weight: bold;
              color: black;
            }

          </style>
        </head>

        <body>
          ${clonedContent.innerHTML}
        </body>
      </html>
    `);

      WindowPrt.document.close();

      setTimeout(() => {
        WindowPrt.focus();
        WindowPrt.print();
        WindowPrt.close();
      }, 500);
    }
  }
  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    try {
      const liveInputs = Array.from(element.querySelectorAll('input'));
      const liveValues = liveInputs.map((inp: any) => inp.value || '');

      const cloned = element.cloneNode(true) as HTMLElement;
      cloned.querySelectorAll('button, .button-container').forEach(el => el.remove());

      const clonedInputs = Array.from(cloned.querySelectorAll('input'));
      clonedInputs.forEach((input, index) => {
        const span = document.createElement('span');
        span.textContent = liveValues[index] ?? '';
        input.replaceWith(span);
      });

      const tables = cloned.querySelectorAll('table');
      const dataTable = tables[tables.length - 1] as HTMLElement;
      if (!dataTable) return;

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(dataTable);

      // Auto column widths
      const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
      const colWidths: { wch: number }[] = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        let maxLen = 10;
        for (let R = range.s.r; R <= range.e.r; R++) {
          const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell?.v) maxLen = Math.max(maxLen, String(cell.v).length);
        }
        colWidths.push({ wch: maxLen + 2 });
      }
      ws['!cols'] = colWidths;

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, fileName + '.xlsx');

    } catch (error) {
      console.error('Export error:', error);
    }
  }

  // ================= EXPORT & PRINT =================
  // Implement exportExcel() and printReportA3() as before
}